import html from "../careers.html?raw";
import scripts from "../scripts/careers.json";

import type { MirrorContent } from "../pages";

export const content: MirrorContent = { html, scripts };
export default content;
